import { api } from '@api'
import { useQuery } from '@tanstack/react-query'
import { Note } from './usePaginateNotes'

interface GetNoteByIdResponse {
  note: Note
}

const fetchNoteById = async (id: string): Promise<Note> => {
  const { data } = await api.get<GetNoteByIdResponse>(`/notes/${id}`)
  return data.note
}

export const useGetNoteById = (id: string) => {
  return useQuery<Note>({
    queryKey: ['note', id],
    queryFn: () => fetchNoteById(id),
    enabled: !!id,
    // The editor saves over the note: it must not start from a copy kept from
    // an earlier visit (the cache is kept for minutes, and across restarts).
    refetchOnMount: 'always',
  })
}

